import { useCallback } from "react";
import { usePermissions } from "@/rbac/usePermissions";

/** Shown wherever a deal control is read-only because of this gate. */
export const DEAL_EDIT_DENIED_MESSAGE = "You can't edit deals in this stage";

/** The stage the DEAL itself sits in — never the parent lead's stage. */
export function dealStageIdOf(deal: any): number {
  return Number(deal?.stageId ?? deal?.stage?.id);
}

/**
 * Role wizard "Choices → Edit choices" (`choice_management.edit`) on the
 * deal's OWN stage. Gates every edit of a deal's data: its fields (name,
 * value …), its custom-field values and its niche links (university,
 * course, service, program …). Strict like "Delete choices" — a missing
 * stage entry or key denies. Stage moves, follow-ups, notes, documents,
 * payments, assignment, create and delete have their own toggles and are
 * NOT gated here. The server enforces the same rule (ChildPolicy).
 */
export function useCanEditDeal() {
  const { canStage, bypassesRbacChecks } = usePermissions();
  return useCallback(
    (dealStageId: unknown): boolean => {
      if (bypassesRbacChecks) return true;
      const sid = Number(dealStageId);
      return Number.isFinite(sid) && canStage(sid, "choice_management", "edit");
    },
    [canStage, bypassesRbacChecks],
  );
}
